import axiosInstance from '../../../../config/axiosInstance';
const  SageSetupService = {
    async GetAllSageSetup(redirectCallback) {
        try {            
            const ClientID=localStorage.getItem('CompanyID');
            const response = await axiosInstance.get(`/Setup/GetAllSageSetup?ClientID=${ClientID}`);
            return response.data;
        } catch (error) {
            if(error.response.data.message=="Invalid token")
            {
                redirectCallback();
                return;
            }
            console.error('Error fetching roles:', error);
            throw error;
        }
    },
    async DeleteSageSetup(ID,redirectCallback) {
        try {
            const response = await axiosInstance.get(`/Setup/DeleteSageSetup?ID=${ID}`);
            return response.data;
        } catch (error) {
            console.error('Error deleting team:', error);
            throw error;
        }
    }
};

export default SageSetupService;